import { render, staticRenderFns } from "./FormSuccess.vue?vue&type=template&id=b4506cb4&scoped=true"
import script from "./FormSuccess.vue?vue&type=script&lang=js"
export * from "./FormSuccess.vue?vue&type=script&lang=js"
import style0 from "./FormSuccess.vue?vue&type=style&index=0&id=b4506cb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4506cb4",
  null
  
)

export default component.exports